module.exports = __webpack_public_path__ + "static/media/nav-icon-search.a5644549.svg";